// @flow
import * as React from 'react'
import cn from 'classnames'
import styles from './ErrorMessage.css'

type ErrorMessageProps = {
  children?: ?React.Node,
  error: { message: string, type?: string },
  hasError: boolean,
  severe?: boolean,
  colSpan?: string
}

const ErrorMessage = ({
  colSpan = '999',
  hasError,
  error,
  severe,
  children
}: ErrorMessageProps) => {
  if (!hasError) {
    return null
  }

  return (
    <tr>
      <td colSpan={colSpan}>
        <div
          className={cn(styles.errorMessage, {
            [styles.errorMessageSevere]: severe
          })}
        >
          <svg height="30" width="30" aria-hidden="true">
            <use xlinkHref="#nrk-info" />
          </svg>
          <span>{error.message}</span>
        </div>
      </td>
    </tr>
  )
}

export default ErrorMessage



// WEBPACK FOOTER //
// ./src/shared/components/ErrorMessage/ErrorMessage.js